import React from 'react';
import Modal from '../Modal'
import { KNOW_MORE } from './../../assets'
import './BrandEngagement.scss'; 
import BrandEngagementV1 from '../../pages/BrandEngagement/BrandEngagementV1'

interface BrandEngagementProps {
  setBrandEngagementVisible: (visible: boolean) => void;
  brandEngagementData: any;
}

interface ModalCardProps {
  imageSrc: string;
  text: string;
  altText: string;
}

const cardData = [
  { imageSrc: KNOW_MORE, text: 'Know More', altText: 'Know More' },
];

const ModalCard: React.FC<ModalCardProps> = ({ imageSrc, text, altText }) => (
  <div
    className="EachModalCard"
  >
    <div>
      <img src={imageSrc} alt={altText} />
    </div>
    <div className="ModalCardText">{text}</div>
  </div>
);

const BrandEngagement: React.FC<BrandEngagementProps> = ({ setBrandEngagementVisible, brandEngagementData }) => {
  return (
    <Modal className="BrandEngagement">
          <div
            className="close-btn"
            onClick={() => setBrandEngagementVisible(false)}
          >
            <span>×</span>
          </div>
        <div
          className="ModalBody"
        >
          <BrandEngagementV1 brandEngagementData={brandEngagementData} hideCta={true} isLiveStream={true}/>
        </div>
     </Modal>
  );
};

export default BrandEngagement;